export const FORUM_MIN_TITLE_LENGTH = 3;
export const FORUM_MAX_TITLE_LENGTH = 200;
export const FORUM_MIN_BODY_LENGTH = 3;
export const FORUM_MAX_BODY_LENGTH = 5000;

export function forumTitleError(raw: string): string | null {
  const title = raw.trim();
  if (title.length < FORUM_MIN_TITLE_LENGTH) {
    return `El título debe tener al menos ${FORUM_MIN_TITLE_LENGTH} caracteres`;
  }
  if (title.length > FORUM_MAX_TITLE_LENGTH) {
    return `El título no puede superar ${FORUM_MAX_TITLE_LENGTH} caracteres`;
  }
  return null;
}

export function forumBodyError(raw: string): string | null {
  const body = raw.trim();
  if (body.length < FORUM_MIN_BODY_LENGTH) {
    return `El mensaje debe tener al menos ${FORUM_MIN_BODY_LENGTH} caracteres`;
  }
  if (body.length > FORUM_MAX_BODY_LENGTH) {
    return `El mensaje no puede superar ${FORUM_MAX_BODY_LENGTH} caracteres`;
  }
  return null;
}

export function forumThreadDraftError(input: { title: string; body: string }): string | null {
  return forumTitleError(input.title) ?? forumBodyError(input.body);
}
